import { createModelReport } from "~/apis/model";
import { ReportObject } from "~/types/report";
import {
  ReportContentType,
  ReasonType,
} from "~/types/request/modelRequest.type";

interface IFormData {
  fileList: Array<{
    fileId: string | number;
    fileName: string;
    fileSize?: number;
    fileExt?: string;
    fileUrl: string;
    extra: any;
  }>;
  bizId: string;
  reportedId: string;
  reportContent: string;
  modelId?: string;
  reasonType: ReasonType | null;
  modelSourceType?: number;
  originUrl?: string;
}

const defaultFormData: IFormData = {
  bizId: "", // 业务id/评论条目id/模型id;
  reportedId: "", // 被举报用户ID
  reportContent: "",
  fileList: [],
  reasonType: null,
  modelSourceType: 0, //模型类型
  originUrl: "",
};

const getReportContentType = (value: ReportObject) => {
  switch (value) {
    case ReportObject.MODEL:
      return ReportContentType.MODEL;
    case ReportObject.COMMENT:
      return ReportContentType.COMMENT;
    case ReportObject.USER:
      return ReportContentType.USER;
  }
};

export const useReportDialogStore = defineStore("reportDialog", {
  state: () => ({
    visible: false,
    loading: false,
    reportDialogType: ReportObject.COMMENT,
    formData: {} as IFormData,
    callbacks: {
      onSuccess: null as Function | null,
      onFail: null as Function | null,
      onClose: null as Function | null,
    },
  }),
  actions: {
    openDialog(payload: {
      type: ReportObject;
      initData?: Partial<IFormData>;
      onSuccess: () => void;
      onFail: () => void;
      onClose?: () => void;
    }) {
      this.reportDialogType = payload.type;
      this.formData = {
        ...defaultFormData,
        ...(payload.initData || {}),
      } as IFormData;
      this.callbacks.onSuccess = payload.onSuccess;
      this.callbacks.onFail = payload.onFail;
      this.callbacks.onClose = payload.onClose || null;
      this.visible = true;
    },
    async handleConfirm() {
      this.loading = true;
      await this.doReport();
      this.loading = false;
    },
    handleClose() {
      this.callbacks.onClose?.();
      this.resetState();
    },
    resetState() {
      this.visible = false;
      this.loading = false;
      this.callbacks = { onSuccess: null, onClose: null, onFail: null };
    },
    async doReport() {
      const postData = {
        contentType: getReportContentType(this.reportDialogType),
        contentId: this.formData.bizId,
        reportedId: this.formData.reportedId,
        description: this.formData.reportContent,
        reason: this.formData.reasonType || ReasonType.WORK_VIOLATION_OTHER,
        modelId: this.formData.modelId,
        attachments: this.formData.fileList.map((item) => ({
          type: 1,
          url: item.fileUrl,
        })),
      };
      let result = false;
      try {
        const response = await createModelReport(postData);
        if (!!response && response.code === 0) {
          result = true;
        }
      } catch (error) {
        console.log("error:", error);
      }
      if (result) {
        this.callbacks.onSuccess && this.callbacks.onSuccess?.();
        this.handleClose();
      } else {
        this.callbacks.onFail && this.callbacks.onFail?.();
      }
    },
  },
});
